import { initContract } from '@ts-rest/core';
import { z } from 'zod';
////////////////////////////////////////////////////////////////////////////////
// getPendingClaims
////////////////////////////////////////////////////////////////////////////////
export const PendingClaim = z.strictObject({
    id: z.string(),
    status: z.enum(['draft', 'filing', 'failed', 'invalid']),
    contractNumber: z.string().nullable(),
    policyHolderName: z.string().nullable(),
    claimDate: z.string().nullable(),
    incidentLocation: z.string().nullable(),
    claimType: z.string().nullable(),
    claimAmountEur: z.number().nullable(),
    filesCount: z.number(),
});
export const GetPendingClaimsResponse = z.strictObject({
    claims: z.array(PendingClaim),
});
////////////////////////////////////////////////////////////////////////////////
// fileMultipleClaims
////////////////////////////////////////////////////////////////////////////////
export const FileMultipleClaimsRequest = z.strictObject({
    claimIds: z.array(z.string()),
});
export const FileMultipleClaimsResponse = z.strictObject({
    filedCount: z.number(),
    skippedCount: z.number(),
});
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const pendingClaimsContract = c.router({
    getPendingClaims: {
        method: 'GET',
        path: '/get-pending-claims',
        responses: {
            200: GetPendingClaimsResponse,
        },
    },
    fileMultipleClaims: {
        method: 'POST',
        path: '/file-multiple-claims',
        body: FileMultipleClaimsRequest,
        responses: {
            200: FileMultipleClaimsResponse,
        },
    },
}, { strictStatusCodes: true, pathPrefix: '/pending-claims' });
